import { cssInterop } from 'nativewind';
import { KeyboardAvoidingView, KeyboardAwareScrollView } from 'react-native-keyboard-controller';

/**
 * Componentes de teclado aceitam `className` como os do React Native (o
 * NativeWind só conhece os nativos). Importado uma vez no `app/_layout.tsx`.
 */
cssInterop(KeyboardAvoidingView, { className: 'style' });
cssInterop(KeyboardAwareScrollView, {
  className: 'style',
  contentContainerClassName: 'contentContainerStyle',
});
